module.exports = __webpack_public_path__ + "static/media/House3.9f008dc7.svg";